export default "__VITE_ASSET__BsRjDWK0__"